import * as joint from '@joint/plus';

export function initializeNavigator(service) {
  service.navigatorService.create(service.paperScroller, {
    width: service.paper.options.width,
    height: service.paper.options.height,
    paperConstructor: joint.dia.Paper,
    paperOptions: {
      model: service.graph,
      gridSize: 1,
      drawGrid: true,
      background: { color: '#ffffff' },
    },
  });
}
